export default {
  methods: {
    handleXhrError (error) {
      if (error) {
        if (process.env.NODE_ENV === 'development') console.log(error)
      }
    }
  }
}
